// Core
import { http } from "@/network/http-provider";

// Definitions
import { profileKeys } from "./apiKeys";
import {
  ChangePasswordType,
  GetTransactionsType,
  PaymentSystem,
  CreatePaymentDataType,
  TransactionListType,
  UpdateProfileParamsType,
  CreateWithdrawDataType,
} from "./types";
import { HttpRequestParams } from "@/types/http";
// Utils

export const profileApi = Object.freeze({
  updateProfile: (payload: UpdateProfileParamsType) => {
    const { data, headers } = payload;
    return http.put<any>(profileKeys.updateProfile, data, { headers });
  },
  getProfileTransactions: (payload: HttpRequestParams<GetTransactionsType>) => {
    const { params, configOptions } = payload;
    return http.get<TransactionListType>(profileKeys.getTransactions, { params, ...configOptions });
  },
  getProfile: (payload: HttpRequestParams<void, void>) => {
    const { configOptions } = payload;
    return http.get<any>(profileKeys.getProfile, { ...configOptions });
  },
  getProfileBalance: (payload: HttpRequestParams<void, void>) => {
    const { configOptions } = payload;
    return http.get<any>(profileKeys.getBalance, { ...configOptions });
  },
  changePassword: (payload: HttpRequestParams<ChangePasswordType>) => {
    const { data, configOptions } = payload;
    return http.put<any>(profileKeys.changePassword, data, configOptions);
  },
  getPaymentSystems: (payload: HttpRequestParams<void>) => {
    const { params, configOptions } = payload;
    return http.get<PaymentSystem[]>(profileKeys.getPaymentSystems, {
      params,
      ...configOptions,
    });
  },
  createPayment: (payload: CreatePaymentDataType) => {
    const { data, headers } = payload;
    return http.post<any>(profileKeys.createPayment, data, { headers });
  },
  createWithdraw: (payload: CreateWithdrawDataType) => {
    const { data, headers } = payload;
    return http.post<any>(profileKeys.createWithdraw, data, { headers });
  },
});
